<template>
    <div class="board" v-if="formData && errorData">
        <div class="bar">
            <b-icon icon="person" class="icon"></b-icon>
            <span>ข้อมูลลูกค้า</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="form">
                <div class="filter mb-3">
                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <div class="field">
                                <label>ทะเบียนรถตามบิล</label>
                                <input type="text"
                                    class="input-field"
                                    v-model="formData.customer.licensePlate"
                                    readonly />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="field">
                                <label class="no-label">-</label>
                                <input type="text"
                                    class="input-field"
                                    :value="displayLicensePlate(formData.customer.licensePlateProvince)"
                                    readonly />
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>ยี่ห้อรถ</label>
                                <input type="text"
                                    class="input-field"
                                    v-model="formData.customer.carBrand"
                                    readonly />
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>รุ่นรถ</label>
                                <input type="text"
                                    class="input-field"
                                    v-model="formData.customer.carModel"
                                    readonly />
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label class="optional">ปีรถ</label>
                                <input type="text"
                                    class="input-field"
                                    v-model="formData.customer.carYearSerie"
                                    readonly />
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>ชื่อลูกค้าตามบิล</label>
                                <input type="text"
                                    class="input-field"
                                    v-model="formData.customer.billName"
                                    readonly />
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>เบอร์ติดต่อตามบิล</label>
                                <input type="text"
                                    class="input-field"
                                    v-model="formData.customer.billTel"
                                    readonly />
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>เลขประจำตัวผู้เสียภาษี</label>
                                <input type="text"
                                    class="input-field"
                                    v-model="formData.customer.billTax"
                                    readonly />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>ชื่อลูกค้ามาเคลม</label>
                            <input type="text" 
                                v-model="formData.customer.claimFirstName"
                                class="input-field"
                                :class="{ 'invalid': errorData.customer.claimFirstName.blank }"
                                :readonly="jobState === $Constants.JOB_STATUS_PENDING"
                                maxlength="100"
                                placeholder="ชื่อลูกค้ามาเคลม" />
                            <div class="input-error-message" v-if="errorData.customer.claimFirstName.blank">โปรดกรอกชื่อลูกค้ามาเคลม</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>นามสกุลลูกค้ามาเคลม</label>
                            <input type="text"
                                v-model="formData.customer.claimLastName"
                                class="input-field"
                                :class="{ 'invalid': errorData.customer.claimLastName.blank }"
                                :readonly="jobState === $Constants.JOB_STATUS_PENDING"
                                maxlength="100"
                                placeholder="นามสกุลลูกค้ามาเคลม" />
                            <div class="input-error-message" v-if="errorData.customer.claimLastName.blank">โปรดกรอกนามสกุลลูกค้ามาเคลม</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>เบอร์ติดต่อผู้มาเคลม</label>
                            <input type="tel"
                                v-model="formData.customer.claimTel"
                                class="input-field"
                                :class="{ 'invalid': errorData.customer.claimTel.blank }"
                                :readonly="jobState === $Constants.JOB_STATUS_PENDING"
                                maxlength="20"
                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                placeholder="เบอร์ติดต่อผู้มาเคลม" />
                            <div class="input-error-message" v-if="errorData.customer.claimTel.blank">โปรดกรอกเบอร์ติดต่อผู้มาเคลม</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';

export default {
    mixins: [ MixinThemeBoard ],
    data() {
        return {
            formData: null,
            licensePlateProvince: ''
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    async mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.formData = this.initForm();
            this.$emit('formData', this.formData);
        },
        bindClaimData(claimData) {
            if (claimData) {
                this.formData.customer.licensePlate = claimData.customer.licensePlate;
                this.formData.customer.licensePlateProvince = claimData.customer.licensePlateProvince;
                this.formData.customer.carBrand = claimData.customer.carBrand;
                this.formData.customer.carModel = claimData.customer.carModel;
                this.formData.customer.carYearSerie = claimData.customer.carYearSerie;

                if (claimData.jobType === this.$Constants.JOB_FORM_FLEET) {
                    this.formData.customer.billName = claimData.fleet.company;
                    this.formData.customer.billTel = claimData.fleet.contactTel;
                    this.formData.customer.billTax = claimData.fleet.taxId;
                } else {
                    this.formData.customer.billName = [ claimData.customer.customerFirstName, claimData.customer.customerLastName ].join(' ');
                    this.formData.customer.billTel = claimData.customer.customerTel;
                    this.formData.customer.billTax = '';
                }

                this.formData.customer.claimFirstName = claimData.customer.customerFirstName;
                this.formData.customer.claimLastName = claimData.customer.customerLastName;
                this.formData.customer.claimTel = claimData.customer.customerTel;
            }
        },
        displayLicensePlate(licensePlate) {
            if (licensePlate) {
                return OptionLicensePlateProvince.service.getValueByKey(licensePlate);
            }
            
            return '';
        },
        initForm() {
            return {
                customer: {
                    licensePlate: this.loadData ? this.loadData.customer.licensePlate : '',
                    licensePlateProvince: this.loadData ? this.loadData.customer.licensePlateProvince : '',
                    carBrand: this.loadData ? this.loadData.customer.carBrand : '',
                    carModel: this.loadData ? this.loadData.customer.carModel : '',
                    carYearSerie: this.loadData ? this.loadData.customer.carYearSerie : '',
                    billName: this.loadData ? this.loadData.customer.billName : '',
                    billTel: this.loadData ? this.loadData.customer.billTel : '',
                    billTax: this.loadData ? this.loadData.customer.billTax : '',
                    claimFirstName: this.loadData ? this.loadData.customer.claimFirstName : '',
                    claimLastName: this.loadData ? this.loadData.customer.claimLastName : '',
                    claimTel: this.loadData ? this.loadData.customer.claimTel : ''
                }
            };
        }
    }
}
</script>